import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import serverWarmup from './utils/serverWarmup.ts';
import { preloadCriticalResources, optimizeForMobile } from './utils/lazyLoad.ts';

// Start server warmup
serverWarmup.start();

// Preload critical resources
preloadCriticalResources();

// Optimize for mobile
optimizeForMobile();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
